import { render, staticRenderFns } from "./MonthlyOrders.vue?vue&type=template&id=050d147a&scoped=true"
import script from "./MonthlyOrders.vue?vue&type=script&lang=ts"
export * from "./MonthlyOrders.vue?vue&type=script&lang=ts"
import style0 from "./MonthlyOrders.vue?vue&type=style&index=0&id=050d147a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050d147a",
  null
  
)

export default component.exports